import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as analyticsActions from 'reduxBits/analytics/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      event: 'event',
      eventType: 'Engagement',
      objectType: 'UIElement',
      domain: 'content',
    },
    ...localData,
  })

export const trackCta = {
  validators: [
    validators.redux(analyticsActions.TRIGGER_CTA_ANALYTICS, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) =>
      createDataLayerObject(state, {
        objectId: 'content-cta-btn',
        objectName: accumulator,
        eventType: 'Engagement',
        eventCategory: 'content',
        eventLabel: accumulator,
        eventAction: 'clicked on cta button',
        origin: {
          id: document.location.pathname + document.location.search,
          url: encodeURI(window.location.href),
        },
      }),
    ),
  ],
}
/* TODO: Replace this function with sendEvent */
export const trackQuickAssCategory = {
  validators: [
    validators.redux(
      analyticsActions.QUICK_ASS_CATEGORY_CLICKED,
      () => true,
      ({ payload }) => payload,
    ),
  ],
  events: [
    gtm.event(({ state, accumulator }) =>
      createDataLayerObject(state, {
        objectId: 'quick-ass-category-picker',
        objectName: accumulator,
        eventType: 'Engagement',
        eventCategory: 'search',
        eventLabel: accumulator,
        eventAction: 'clicked on quick ass category picker',
        origin: {
          id: document.location.pathname + document.location.search,
          url: encodeURI(window.location.href),
        },
      }),
    ),
  ],
}
